
import { reactive, onMounted, ref, defineComponent } from "vue";
import Confirm from "@/components/confirm/confirm.vue";
import { uploadAsset, getMaterial, deleteMaterial, getSpace } from "@/apis/ad";
import { ElMessage } from "element-plus";
import { memoryFormat, timeFormat } from "@/utils/format";
import { showStatus } from "@/utils/constant";
import i18n from "@/locales/index";
import dayjs from "dayjs";
const _t = i18n.global.t;
import { getLanguage } from "@/utils/cookies";

export default defineComponent({
  components: {
    Confirm
  },
  setup() {
    const uploadRef = ref();
    const space = ref(0);
    const loading = ref(false);
    const table = reactive({
      total: 0,
      page: 1,
      pageSize: 10,
      data: [] as any[]
    });

    const dialog = reactive({
      visiable: false,
      url: "",
      type: "image",
      filename: ""
    });

    const errorColor = (percent: number, uploading: any) => {
      if (percent === 500) return "#f5222d";
      if (uploading) return "#606266";
      if (percent > 0 && percent < 100) {
        return "#f5222d";
      }
      return "#606266";
    };

    const getTableList = () => {
      const { page, pageSize } = table;
      getMaterial({ page, pageSize, limit: true }).then((res: any) => {
        if (res.code === 200) {
          const { list, total } = res.data;
          table.data = list;
          table.total = total;
        }
      });
    };

    const handleUpload = async (file: File) => {
      loading.value = true;
      const { name, size } = file;
      const type =
        name
          .split(".")
          .pop()
          ?.toLocaleLowerCase() || "";
      const extMap = {
        jpg: "image",
        png: "image",
        mp4: "video",
        avi: "video",
        mov: "video",
        wmv: "video",
        rmvb: "video"
      };

      // 文件校验
      if (!extMap[type]) {
        ElMessage.error(_t("ad.extLimit"));
        loading.value = false
        return Promise.reject();
      }
      if (size > space.value) {
        ElMessage.error(_t("ad.notEnoughSpace"));
        loading.value = false
        return Promise.reject();
      }
      if (size > 1024 * 1024 * 1024) {
        ElMessage.error(_t("ad.sizeLimit"));
        loading.value = false
        return Promise.reject();
      }

      const id = new Date().getTime();
      // if (table.data.length === table.pageSize) table.data.pop();
      table.data.unshift({
        id,
        size,
        file_name: name,
        upload_time: (dayjs().valueOf() / 1000) | 0,
        type: extMap[type],
        syn_percentage: 0,
        uploading: true // 这里给数据加了一个状态表明正在上传中
      });

      const formData = new FormData();
      formData.append("file", file);
      const index = table.data.findIndex(item => item.id === id);
      const res: any = await uploadAsset(formData, (progressEvent: any) => {
        const percent = Math.floor(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log("percent: ", percent);
        if(table.page === 1){
          table.data[index].uploading = percent;
          table.data[index].syn_percentage = percent;
        }
      });
      if (res.data?.code === 200) {
        ElMessage.success(_t("ad.uploadSuccess"));
      }else if(res.data?.code === 30005){
        ElMessage.error(_t("ad.notEnoughSpace"));
      } else {
        ElMessage.error(res.msg);
      }
      getRemainSpace();
      getTableList();
      loading.value = false;
      return Promise.reject(); //阻止el-upload组件的默认行为
    };

    const handleClose = () => {
      dialog.visiable = false;
    };

    const operation_width = () => {
      let language = getLanguage()
      if (language == 'fr' || language == 'nl') {
        return 150
      } else {
        return 120
      }
    };

    const handleCheck = (row: any) => {
      dialog.visiable = true;
      dialog.filename = row.file_name;
      dialog.url = row.url;
      dialog.type = row.type === "video" ? "video" : "image";
    };

    const handleDelete = (row: any) => {
      deleteMaterial(row.id).then((res: any) => {
        console.log(res);
        if (res.code === 200) {
          ElMessage.success(_t("ad.deleteSuccess"));
          getTableList();
          getRemainSpace();
        } else if (res.code === 10018) {
          ElMessage.error(_t("ad.cannotDeleteAssetUsed"));
        } else {
          ElMessage.error(res.msg);
        }
      });
    };

    const handlePageChange = (page: number) => {
      table.page = page;
      getTableList();
    };

    const handleSizeChange = (pageSize: number) => {
      table.pageSize = pageSize;
      table.page = 1;
      getTableList();
    };

    const memoryFormat = (size: number) => {
      let result = ''
      // G
      if (size > 1024 * 1024 * 1024) {
        result = (size / (1024 * 1024 * 1024)).toFixed(1) + "GB";
      }
      // MB
      else if (size > 1024 * 1024) {
        result = (size / (1024 * 1024)).toFixed(0) + "MB";
      }
      // KB
      else if (size > 1024) {
        result = (size / 1024).toFixed(0) + "KB";
      }
      // B
      else {
        result = size + "B";
      }

      return result
    }

    const getRemainSpace = () => {
      getSpace().then((res: any) => {
        if (res.code === 200) {
          space.value = res.data;
        }
      });
    };

    onMounted(() => {
      getTableList();
      getRemainSpace();
    });

    return {
      uploadRef,
      space,
      table,
      dialog,
      operation_width,
      handleUpload,
      handleClose,
      handleCheck,
      handleDelete,
      handlePageChange,
      handleSizeChange,
      timeFormat,
      memoryFormat,
      showStatus,
      errorColor,
      loading
    };
  }
});
